import React, { useRef } from 'react'
import { useNavigate } from "react-router-dom";

import { Button, Typography, Divider, Switch } from '@mui/material'
import { Box, styled } from '@mui/system'

import { ArrowLeftIcon, ClockIcon } from 'Sui_Icons';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { convertHourToPersianDigit } from 'utils';


const Tag = styled(Box)({
    backgroundColor: 'rgba(5, 198, 197, 0.1)',
    borderRadius:'5px',
    color: '#05C6C5',
    fontSize: '12px',
    padding: '4px',
    width: 'fit-content',
    '&:not(:last-child)': {
        marginRight: '8px'
    }
})

let URL;
if (process.env.NODE_ENV === "production") {
    URL = `${process.env.REACT_APP_PRODUCTION_API_URL}`;
} else {
    URL = `${process.env.REACT_APP_DEVELOPMENT_API_URL}`;
}

export const DashboardCourseCard = ({ img, title, caption, teacherName, teacherPhoto, length, price, id, tags ,visible , onVisible , onDelete , index}) => {
    console.log(title);
    console.log(length);
    
    const navigate = useNavigate();
    const descriptionRef = useRef();


    function truncateHTML(html, maxWords) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const allNodes = doc.body.childNodes;
    
        let wordCount = 0;
        let isTruncated = false;
    
        const walkNodes = (node) => {
            if (isTruncated) return;  // Stop recursion once truncated
            if (node.nodeType === Node.TEXT_NODE) {
                let words = node.textContent.split(/\s+/).filter(word => word.length);
                if (wordCount + words.length > maxWords) {
                    words = words.slice(0, maxWords - wordCount);
                    node.textContent = words.join(' ') + '...';
                    isTruncated = true;
                }
                wordCount += words.length;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                Array.from(node.childNodes).forEach(walkNodes);
                if (isTruncated) {
                    while (node.nextSibling) {
                        node.parentNode.removeChild(node.nextSibling);
                    }
                }
            }
        };
    
        Array.from(allNodes).forEach(walkNodes);
    
        return doc.body.innerHTML;
    }

    const truncatedCaption = truncateHTML(caption, 15);

    return (
        <Box sx={{ px: { xs: 4, lg: 2 }, py: 2, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 2, position: 'relative', bottom: 0, transition: 'all ease 0.4s', color: 'CaptionText' }} component={'a'} >
            <Box sx={{ borderRadius: 1.1, mb: 2, position: 'relative', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ height: { xs: '180px', lg: '170px' }, width: { xs: '100%', lg: '100%' } }}><img style={{ width: '100%', height: '100%', borderRadius: '9px' }}                          
                    src={`${URL}/api/v1/${img}`} />
                </Box>

                <Box sx={{ position: 'absolute', bottom: '5%', left: '5%', py: 0.5, px: 1, background: 'white', borderRadius: 1, display: 'flex', alignItems: 'center', verticalAlign: 'middle' }}>
                    <ClockIcon sx={{ mr: 0.5 }} />
                    <Typography sx={{ mt: 0.5 }} color='primary.main' fontSize={14}>{convertHourToPersianDigit(length)}</Typography>
                </Box>
            </Box>

            <Typography gutterBottom fontSize={14} fontWeight={'bold'} >{title}</Typography>

            <Box width={'100%'} display={'flex'} flexWrap={'wrap'} my={1}>
                {tags.map(tag => <Tag>{tag?.title}</Tag>)}
            </Box>

            <Typography ref={descriptionRef} gutterBottom color='grey.600' fontSize={13} dangerouslySetInnerHTML={{ __html: truncatedCaption }} />            

            <Divider />

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                <Button 
                    startIcon={<VisibilityIcon sx={{ color: '#FFBF5F' }} />} 
                    onClick={() => navigate(`/coursedetail/${id}`)}
                    sx={{
                        backgroundColor: 'rgba(255, 191, 95, 0.15)',
                        '&:hover': { backgroundColor: 'rgba(255, 191, 95, 0.15)' },
                        borderRadius: '5px',
                        p: 1.2
                    }}>
                    <Typography color='CaptionText' fontSize={13}>پیش نمایش</Typography>
                </Button>

                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography fontSize={14} fontWeight={'medium'}>قابل رویت</Typography>
                    &nbsp;&nbsp;
                    <Switch color='primary'
                     checked={visible} 
                     onChange={()=>onVisible(id)} 
                     />
                </Box>
            </Box>


            <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderRadius: 1,
                py: 1.5,
                px: 1,
            }}>
                <Button color='error' variant='text' onClick={()=>onDelete(id, true)} startIcon={<DeleteOutlineIcon color='error'
                        // onClick={() => {
                        //     confirmDialog('Do you really want to delete all the data?', () =>
                        //     console.log('deleting all the data!')
                        //     );
                        // }} 
                    />}>
                    <Typography color='error.main' fontSize={13} fontWeight={500}>
                        حذف
                    </Typography>
                </Button>

                <Button href={`edit/${id}`} endIcon={<ArrowLeftIcon size={'25px'} />}><Typography color='primary.main' fontWeight={700} fontSize={14}>ویرایش</Typography></Button>

            </Box>

        </Box>
    )

}
